<div class="login-container d-flex align-items-center justify-content-center min-vh-100 bg-light">
  <div class="login-card">
    <div class="card shadow-lg border-0" style="max-width: 450px; width: 100%;">
      
      <!-- Header -->
      <div class="card-header bg-primary text-white text-center py-4">
        <img src="/uncp-logo2.png" alt="UNCP Logo" class="img-fluid mb-3" style="max-height: 80px;">
        <h4 class="mb-1 fw-bold">{{ env.appName }}</h4>
        <p class="mb-0 small">{{ env.institucion }}</p>
      </div>

      <div class="card-body p-4">
        
        <!-- Mensajes de error -->
        <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ errorMessage }}
          <button type="button" class="btn-close" (click)="errorMessage = ''" aria-label="Close"></button>
        </div>

        <!-- Login con Office 365 (Principal) -->
        <div *ngIf="!showTraditionalLogin">
          <div class="text-center mb-4">
            <h5 class="fw-bold text-dark">Iniciar Sesión</h5>
            <p class="text-muted">Utiliza tu cuenta institucional de Office 365</p>
          </div>

          <!-- Botón Office 365 -->
          <button 
            type="button" 
            class="btn btn-primary btn-lg w-100 mb-3 d-flex align-items-center justify-content-center"
            (click)="loginWithOffice365()" 
            [disabled]="loading">
            
            <span *ngIf="!loading" class="d-flex align-items-center">
              <i class="fab fa-microsoft me-3 fs-5"></i>
              Continuar con Office 365
            </span>
            
            <span *ngIf="loading" class="d-flex align-items-center">
              <span class="spinner-border spinner-border-sm me-3" role="status"></span>
              Conectando...
            </span>
          </button>

          <!-- Información adicional -->
          <div class="bg-light p-3 rounded mb-0">
            <small class="text-muted">
              <i class="fas fa-info-circle me-2"></i>
              Utiliza tu correo institucional <strong>uncp.edu.pe</strong> para acceder al sistema.
            </small>
          </div>

        </div>

        <!-- Login Tradicional (Alternativo) -->
        <div *ngIf="showTraditionalLogin">
          <div class="text-center mb-4">
            <h5 class="fw-bold text-dark">Login Tradicional</h5>
            <p class="text-muted">Utiliza tu usuario y contraseña del sistema</p>
          </div>

          <form #loginForm="ngForm">
            <!-- Campo Usuario -->
            <div class="mb-3">
              <label for="username" class="form-label fw-semibold">Usuario</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-user text-muted"></i>
                </span>
                <input 
                  type="text" 
                  class="form-control" 
                  id="username"
                  name="username"
                  [(ngModel)]="loginData.t1_user"
                  placeholder="Ingrese su usuario"
                  required
                  [disabled]="loading">
              </div>
            </div>

            <!-- Campo Contraseña -->
            <div class="mb-4">
              <label for="password" class="form-label fw-semibold">Contraseña</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-lock text-muted"></i>
                </span>
                <input 
                  type="password" 
                  class="form-control" 
                  id="password"
                  name="password"
                  [(ngModel)]="loginData.t1_password"
                  placeholder="Ingrese su contraseña"
                  required
                  [disabled]="loading">
              </div>
            </div>

            <!-- Botón Submit -->
            <button 
              type="submit" 
              class="btn btn-success btn-lg w-100 mb-3"
              [disabled]="loading || !loginForm.form.valid">
              
              <span *ngIf="!loading">
                <i class="fas fa-sign-in-alt me-2"></i>
                Iniciar Sesión
              </span>
              
              <span *ngIf="loading">
                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                Iniciando sesión...
              </span>
            </button>
          </form>

          <!-- Volver a Office 365 -->
          <div class="text-center">
            <button 
              type="button" 
              class="btn btn-link text-decoration-none p-0"
              (click)="toggleLoginMethod()">
              <small>
                <i class="fas fa-arrow-left me-1"></i>
                Volver a Office 365
              </small>
            </button>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="card-footer bg-light text-center py-3">
        <small class="text-muted">
          {{ env.oficina }}<br>
          <strong>v{{ env.version }}</strong>
          <span *ngIf="!env.production" class="badge bg-warning text-dark ms-2">DEV</span>
        </small>
      </div>

    </div>
  </div>
</div>
